import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import ThreeDotBouncingLoader from "../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import FeedbackForm from "../../../LearningFeedback/FeedbackForm";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import { getLearningFeedbackById, clearLearningFeedbackById } from "../../../../redux/LearningFeedback/learningFeedbackSlice";
import {
  selectLearningFeedbackById,
  selectLearningFeedbackByIdLoading,
} from "../../../../redux/LearningFeedback/learningFeedbackSelectors";

const FeedbackViewPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const feedback = useSelector(selectLearningFeedbackById);
  const loading = useSelector(selectLearningFeedbackByIdLoading);

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        { label: "Learning & Feedback", url: "/learning-feedback", home: "/dashboard" },
        { label: "View Feedback", url: `/learning-feedback/${id}` },
      ])
    );
    dispatch(getLearningFeedbackById(id));
    return () => {
      dispatch(clearLearningFeedbackById());
    };
  }, [dispatch, id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <ThreeDotBouncingLoader />
      </div>
    );
  }

  if (!feedback) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <p className="text-gray-500 text-sm">No feedback found.</p>
      </div>
    );
  }

  return (
    <FeedbackForm
      viewMode
      initialData={feedback}
      onClose={() => navigate("/learning-feedback")}
    />
  );
};

export default FeedbackViewPage;
